import React from 'react';
import { View } from 'react-native';

import Body from '../common/Body';
import Inventory from './Inventory';

import heroStore from '../../stores/hero';

import { PADDING } from '../styleConstants';

// eslint-disable-next-line
export default ({ navigation }: { navigation: any }) => (
  <View style={{ flex: 1, flexDirection: 'row' }}>
    <View>
      <Body navigation={navigation} undressEnabled warrior={heroStore.hero} />
    </View>
    <View style={{ marginLeft: PADDING }}>
      <Inventory />
    </View>
  </View>
);
